import { render, staticRenderFns } from "./my-table.vue?vue&type=template&id=65c63896&scoped=true&"
import script from "./my-table.vue?vue&type=script&lang=js&"
export * from "./my-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c63896",
  null
  
)

export default component.exports